module.exports = __webpack_public_path__ + "img/US_IgnoreArmor_ua.d68ea375.webp";